var CoreContract = /* @__PURE__ */ ((CoreContract2) => {
  CoreContract2["Root"] = "root";
  CoreContract2["Accounts"] = "accounts";
  CoreContract2["Blocklog"] = "blocklog";
  CoreContract2["Governance"] = "governance";
  CoreContract2["Errors"] = "errors";
  CoreContract2["evm"] = "evm";
  return CoreContract2;
})(CoreContract || {});
var RootContractMethod = /* @__PURE__ */ ((RootContractMethod2) => {
  RootContractMethod2["FindContract"] = "findContract";
  RootContractMethod2["GetContractRecords"] = "getContractRecords";
  return RootContractMethod2;
})(RootContractMethod || {});
var AccountsContractMethod = /* @__PURE__ */ ((AccountsContractMethod2) => {
  AccountsContractMethod2["Deposit"] = "deposit";
  AccountsContractMethod2["Withdraw"] = "withdraw";
  AccountsContractMethod2["TransferAllowanceTo"] = "transferAllowanceTo";
  AccountsContractMethod2["TransferAccountToChain"] = "transferAccountToChain";
  AccountsContractMethod2["SetCoinMetadata"] = "setCoinMetadata";
  AccountsContractMethod2["DeleteCoinMetadata"] = "deleteCoinMetadata";
  AccountsContractMethod2["Balance"] = "balance";
  AccountsContractMethod2["BalanceBaseToken"] = "balanceBaseToken";
  AccountsContractMethod2["BalanceBaseTokenEVM"] = "balanceBaseTokenEVM";
  AccountsContractMethod2["BalanceCoin"] = "balanceCoin";
  AccountsContractMethod2["TotalAssets"] = "totalAssets";
  AccountsContractMethod2["AccountObjects"] = "accountObjects";
  AccountsContractMethod2["AccountObjectsInCollection"] = "accountObjectsInCollection";
  AccountsContractMethod2["GetAccountNonce"] = "getAccountNonce";
  AccountsContractMethod2["ObjectBCS"] = "objectBCS";
  return AccountsContractMethod2;
})(AccountsContractMethod || {});
var BlocklogContractMethod = /* @__PURE__ */ ((BlocklogContractMethod2) => {
  BlocklogContractMethod2["GetBlockInfo"] = "getBlockInfo";
  BlocklogContractMethod2["GetRequestIDsForBlock"] = "getRequestIDsForBlock";
  BlocklogContractMethod2["GetRequestReceipt"] = "getRequestReceipt";
  BlocklogContractMethod2["GetRequestReceiptsForBlock"] = "getRequestReceiptsForBlock";
  BlocklogContractMethod2["IsRequestProcessed"] = "isRequestProcessed";
  BlocklogContractMethod2["GetEventsForRequest"] = "getEventsForRequest";
  BlocklogContractMethod2["GetEventsForBlock"] = "getEventsForBlock";
  return BlocklogContractMethod2;
})(BlocklogContractMethod || {});
var GovernanceContractMethod = /* @__PURE__ */ ((GovernanceContractMethod2) => {
  GovernanceContractMethod2["RotateStateController"] = "rotateStateController";
  GovernanceContractMethod2["AddAllowedStateControllerAddress"] = "addAllowedStateControllerAddress";
  GovernanceContractMethod2["RemoveAllowedStateControllerAddress"] = "removeAllowedStateControllerAddress";
  GovernanceContractMethod2["DelegateChainOwnership"] = "delegateChainOwnership";
  GovernanceContractMethod2["ClaimChainOwnership"] = "claimChainOwnership";
  GovernanceContractMethod2["SetFeePolicy"] = "setFeePolicy";
  GovernanceContractMethod2["SetGasLimits"] = "setGasLimits";
  GovernanceContractMethod2["SetEVMGasRatio"] = "setEVMGasRatio";
  GovernanceContractMethod2["AddCandidateNode"] = "addCandidateNode";
  GovernanceContractMethod2["RevokeAccessNode"] = "revokeAccessNode";
  GovernanceContractMethod2["ChangeAccessNodes"] = "changeAccessNodes";
  GovernanceContractMethod2["StartMaintenance"] = "startMaintenance";
  GovernanceContractMethod2["StopMaintenance"] = "stopMaintenance";
  GovernanceContractMethod2["SetPayoutAgentID"] = "setPayoutAgentID";
  GovernanceContractMethod2["GetAllowedStateControllerAddresses"] = "getAllowedStateControllerAddresses";
  GovernanceContractMethod2["GetChainOwner"] = "getChainOwner";
  GovernanceContractMethod2["GetChainInfo"] = "getChainInfo";
  GovernanceContractMethod2["GetFeePolicy"] = "getFeePolicy";
  GovernanceContractMethod2["GetGasLimits"] = "getGasLimits";
  GovernanceContractMethod2["GetEVMGasRatio"] = "getEVMGasRatio";
  GovernanceContractMethod2["GetChainNodes"] = "getChainNodes";
  GovernanceContractMethod2["GetMaintenanceStatus"] = "getMaintenanceStatus";
  GovernanceContractMethod2["GetPayoutAgentID"] = "getPayoutAgentID";
  GovernanceContractMethod2["GetMetadata"] = "getMetadata";
  return GovernanceContractMethod2;
})(GovernanceContractMethod || {});
var ErrorsContractMethod = /* @__PURE__ */ ((ErrorsContractMethod2) => {
  ErrorsContractMethod2["RegisterError"] = "registerError";
  ErrorsContractMethod2["GetErrorMessageFormat"] = "getErrorMessageFormat";
  return ErrorsContractMethod2;
})(ErrorsContractMethod || {});
var EVMContractMethod = /* @__PURE__ */ ((EVMContractMethod2) => {
  EVMContractMethod2["RegisterERC20Coin"] = "registerERC20Coin";
  EVMContractMethod2["SendTransaction"] = "sendTransaction";
  EVMContractMethod2["CallContract"] = "callContract";
  EVMContractMethod2["RegisterERC721NFTCollection"] = "registerERC721NFTCollection";
  EVMContractMethod2["NewL1Deposit"] = "newL1Deposit";
  EVMContractMethod2["GetChainID"] = "getChainID";
  return EVMContractMethod2;
})(EVMContractMethod || {});
export {
  AccountsContractMethod,
  BlocklogContractMethod,
  CoreContract,
  EVMContractMethod,
  ErrorsContractMethod,
  GovernanceContractMethod,
  RootContractMethod
};
//# sourceMappingURL=contracts.enums.js.map
